import { render, staticRenderFns } from "./PolicyHelpList2.vue?vue&type=template&id=384c0d14&"
import script from "./PolicyHelpList2.vue?vue&type=script&lang=js&"
export * from "./PolicyHelpList2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports